import React, { useState as classicUseState } from 'react';

import { State, useState } from '@hookstate/core';

import CloseImage from '@assets/svg/close-ticket.svg';

import { useMutation } from 'react-query';
import { SearchBarExpansiveManufacturer } from '@components';
import { getManufacturersNames } from '@services/queries/manufacturers';
import { ManufacturerNameAndId } from '@services/queries/manufacturers/getManufacturersNames/getManufacturersNames';
import { createProduct } from '@services/queries/products';
import { CriticalDataProduct } from '@components/SearchBars/SearchBarExpansiveModel/SearchBarExpansiveModel';
import { CSSTransition } from 'react-transition-group';
import { AddManufacturerContent } from '@pages/Products/components/AddEquipmentModal/components/AddProduct/components/AddManufacturerContent/AddManufacturerContent';
import { ProductRequest } from '@pages/Products/components/AddEquipmentModal/AddEquipmentModal';
import {
  Container,
  Label,
  Header,
  Buttons,
  StyledInput,
  BlueButton,
  WindowButton,
  WindowButtonImage,
  LabelLight,
  CloseButton,
} from './AddProductContent.styles';

interface IAddFieldContent {
  openAddField: State<boolean>;
  updateDataSelected?: (products?: ProductRequest[]) => void;
  nextBody?: () => void;
  onSelect?: (input: CriticalDataProduct) => void;
}

const AddProductContent = ({
  openAddField,
  updateDataSelected,
  nextBody,
  onSelect,
}: IAddFieldContent) => {
  const [searchTextManufacturer, setSearchTextManufacturer] =
    classicUseState('');
  const [modelNumber, setModelNumber] = classicUseState('');
  const [selectedManufacturer, setSelectedManufacturer] =
    classicUseState<ManufacturerNameAndId>({ name: '', id: '' });
  const [modelName, setModelName] = classicUseState('');
  const [modelDescription, setModelDescription] = classicUseState('');
  const [ManufacturerNames, setManufacturerNames] = classicUseState<
    ManufacturerNameAndId[]
  >([]);
  const [loadingSearchManufacturer, setLoadingSearchManufacturer] =
    classicUseState(false);
  const [alreadySearchManufacturer, setAlreadySearchManufacturer] =
    classicUseState(false);
  const [showErasedSearchManufacturer, setShowErasedManufacturer] =
    classicUseState(false);
  const mutationCreateProduct = useMutation(createProduct, {
    onSuccess: product => {
      if (updateDataSelected)
        updateDataSelected([
          {
            product,
            quantity: 1,
            id: `${product.manufacturerId}-${product.id}-${modelName}`,
          },
        ]);
      if (nextBody) nextBody();
      if (onSelect)
        onSelect({
          id: product.id,
          content: product.model,
          manufacturerName: product?.manufacturer?.name ?? null,

          // manufacturerImg: product?.manufacturer?.imageUrl ?? null,
        });
      openAddField.set(false);
    },
    onError: () => {
      //  toast.error('Updated failed!');
    },
  });

  const mutationGetManufacturersNames = useMutation(getManufacturersNames, {
    onSuccess: result => {
      setLoadingSearchManufacturer(false);
      setShowErasedManufacturer(true);
      setAlreadySearchManufacturer(true);
      setManufacturerNames(result);
    },
  });
  const searchFuncManufacturer = (input: string) => {
    setShowErasedManufacturer(false);
    setSearchTextManufacturer(input);
  };
  const startSearchManufacturer = (input: string) => {
    setLoadingSearchManufacturer(true);
    mutationGetManufacturersNames.mutate(input);
  };
  const onPressEnterManufacturer = (event: any) => {
    if (event.key === 'Enter') {
      startSearchManufacturer(searchTextManufacturer);
    }
  };
  const open = useState(false);
  return (
    <Container>
      <Header>
        New Product
        <CloseButton
          onClick={() => {
            openAddField.set(false);
          }}
        >
          <WindowButtonImage src={CloseImage} />
        </CloseButton>
      </Header>
      <Label>Manufacturer</Label>
      <SearchBarExpansiveManufacturer
        isDisabled={selectedManufacturer.id.length > 0}
        showOptions={ManufacturerNames}
        setShowOptions={setManufacturerNames}
        searchText={searchTextManufacturer}
        placeholder="Find a Manufacturer"
        loadingSearch={loadingSearchManufacturer}
        alreadySearch={alreadySearchManufacturer}
        showErasedSearch={showErasedSearchManufacturer}
        searchOnKeyDown={onPressEnterManufacturer}
        searchIconOnClick={() =>
          startSearchManufacturer(searchTextManufacturer)
        }
        closeIconOnClick={() => {
          setManufacturerNames([]);
          setShowErasedManufacturer(false);
          setSelectedManufacturer({ name: '', id: '' });
          setAlreadySearchManufacturer(false);
          setSearchTextManufacturer('');
          setLoadingSearchManufacturer(false);
        }}
        searchOnChange={searchFuncManufacturer}
        onClickFilter={input => {
          setSelectedManufacturer(input);
          setSearchTextManufacturer(input.name);
          setManufacturerNames([]);
        }}
        labelMissingSearch="Add New Manufacturer"
        whenMissingClicked={() => open.set(true)}
      />
      <Label>Model #</Label>
      <StyledInput
        type="text"
        name="name"
        value={modelNumber}
        onChange={e => setModelNumber(e.target.value)}
      />
      <Label>Product Name</Label>
      <StyledInput
        type="text"
        name="name"
        value={modelName}
        onChange={e => setModelName(e.target.value)}
      />
      <LabelLight>Description (optional)</LabelLight>
      <StyledInput
        type="text"
        name="name"
        value={modelDescription}
        onChange={e => setModelDescription(e.target.value)}
      />
      <Buttons>
        <WindowButton
          onClick={() => {
            openAddField.set(false);
          }}
        >
          Cancel
        </WindowButton>
        <div style={{ width: 16 }} />
        <BlueButton
          disabled={
            !(
              modelName.length > 0 &&
              modelNumber.length > 0 &&
              selectedManufacturer.id.length > 0
            )
          }
          onClick={() => {
            if (
              modelName.length > 0 &&
              modelNumber.length > 0 &&
              selectedManufacturer.id.length > 0
            )
              mutationCreateProduct.mutate({
                data: {
                  name: modelName,
                  model: modelNumber,
                  description: modelDescription || undefined,
                  manufacturerId: selectedManufacturer.id,
                },
              });
          }}
        >
          + Add Product
        </BlueButton>
      </Buttons>
      <CSSTransition
        in={open.get()}
        timeout={1}
        classNames="my-node"
        unmountOnExit
        onEnter={() => open.set(true)}
        onExited={() => open.set(false)}
      >
        <AddManufacturerContent
          openAddField={open}
          setSelectedManufacturer={(name: string, id: string) => {
            setSelectedManufacturer({ name, id });
            setSearchTextManufacturer(name);
          }}
        />
      </CSSTransition>
    </Container>
  );
};

export { AddProductContent };
